<template>
  <generic-in-app-screen>
    <b-container class="flex-grow-1 d-flex flex-column">
      <h1 class="my-5">
        <b>{{ $t('project_export') }}</b>
      </h1>

      &nbsp;

      <b-card :header="$t('encrypt_exported_project')" class="mt-4">
        <b-form-group>
          <label>
            <b> {{ $t('enter_zip_passphrase') }} </b>
          </label>
          <b-form-input
            v-model="passphrase"
            :placeholder="$t('enter_zip_passphrase')"
          />
        </b-form-group>
      </b-card>

      <b-card :header="$t('download_to_local_client')" class="mt-4">
        <b-form-group>
          <label>
            <b> {{ $t('export_filename') }} </b>
          </label>
          <b-form-input
            v-model="filename"
            :placeholder="$t('enter_export_filename')"
          />
        </b-form-group>

        <b-button
          block
          variant="outline-secondary"
          class="mt-3"
          :disabled="disabled_export"
          @click="download_export"
        >
          {{ $t('download_export') }}
        </b-button>
      </b-card>

      <b-card :header="$t('save_to_distant_server')" class="mt-4">
        <filepath-selector
          v-model="export_file"
          class="mt-3"
          :placeholder="$t('selected_export_file')"
          :is_open="false"
        />
        <b-button
          block
          variant="outline-secondary"
          class="mt-3"
          :disabled="disabled_export"
          @click="save_export"
        >
          {{ $t('save_export') }}
        </b-button>
      </b-card>
    </b-container>
  </generic-in-app-screen>
</template>

<style scoped>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
</style>

<i18n>
{
  "en": {
    "project_export": "Exporting the project",
    "encrypt_exported_project": "Encrypt exported project",
    "export_filename": "Name given to the export file",
    "enter_zip_passphrase": "Passphrase to encrypt the export file",
    "enter_export_filename": "Enter the filename you want",
    "download_export": "Download export file",
    "save_export": "Save exported project to selected location",
    "ask_export_files": "Do you want to export the files ?",
    "download_to_local_client": "Download to local browser / client",
    "save_to_distant_server": "Save to distant server"
  },
  "fr": {
    "project_export": "Export du projet",
    "encrypt_exported_project": "Chiffrer le projet exporté",
    "export_filename": "Nom donné au fichier d'export",
    "enter_zip_passphrase": "Mot de passe pour chiffrer le fichier d'export",
    "enter_export_filename": "Entrez le nom de fichier que vous souhaitez",
    "download_export": "Télécharger le fichier d'export",
    "save_export": "Sauvegarder le project exporté à l'emplacement sélectionné",
    "ask_export_files": "Voulez vous également exporter les fichiers ?",
    "download_to_local_client": "Recevoir dans le navigateur / client local",
    "save_to_distant_server": "Sauvegarder dans le serveur distant"
  }
}
</i18n>

<script>
import { subscription_mixin, project_mixin } from '@/components/mixin.js'

import {
  export_project_to_token,
  save_from_token,
  download_file,
  get_hash_project,
} from '@/api/subscriptions.js'
import { GenericPath } from '@/components/object_model.js'

import FilepathSelector from '@/components/filepath_selector.vue'

import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

export default {
  name: 'ProjectExport',
  components: {
    FilepathSelector,
    GenericInAppScreen,
  },
  mixins: [subscription_mixin, project_mixin],
  data() {
    return {
      filename: 'project_export.cwf',
      disabled_export: false,
      passphrase: '',
      export_file: new GenericPath(),
    }
  },
  computed: {
    // project_id() {
    //   let route = this.$route.path
    //   let regexp = new RegExp('(\\d)*/export')
    //   let regexp_match = route.match(regexp)[0].split('/')
    //   // console.log('regexp_match : ', regexp_match)
    //   let res = Number(regexp_match[0])
    //   return res
    //   // return Number(route.match(regexp)[0].split('/')[0])
    // },
  },
  beforeMount() {
    this.fetch_collections(['projects', 'users', 'project_rights'])
  },
  async mounted() {
    let hash = await get_hash_project(this.project_id)
    this.filename = 'project_export_' + hash + '.cwf'
    this.export_file = new GenericPath('project_export_' + hash + '.cwf')
  },
  methods: {
    async download_export() {
      // Export is two api calls :
      // First one is to actually create the export zip file
      // Second is to download this file
      this.disabled_export = true
      let token = await export_project_to_token(
        this.project_id,
        this.passphrase
      )
      // console.log('token : ', token)

      let download_url = `/api/projects/${
        this.project_id
      }/download_from_token/${token}/`
      let res = await download_file(download_url, this.filename)
      this.disabled_export = false
    },
    /*async download_export() {
      this.disabled_export = true
      let base_url = `/api/projects/${this.project_id}/export/${this.passphrase}/filename/`
      let res = await download_file(base_url, this.filename)
      this.disabled_export = false
    },*/
    /*async download_export() {
      this.disabled_export = true
      let base_url = `/api/projects/${this.project_id}/export/`
      let res = await download_file_with_passphrase(base_url, this.filename, this.passphrase)
      this.disabled_export = false
    },*/
    // async download_export() {
    //   let secured_filename = await secure_filename(this.filename)
    //   let url = `/api/projects/${this.project_id}/export/${secured_filename}`
    //   let a = document.createElement('A')
    //   a.href = url
    //   a.download = url.substr(url.lastIndexOf('/') + 1)
    //   document.body.appendChild(a)
    //   try {
    //     a.click()
    //   } finally {
    //     document.body.removeChild(a)
    //   }
    // },
    async save_export() {
      this.disabled_export = true
      let token = await export_project_to_token(
        this.project_id,
        this.passphrase
      )
      // console.log('token : ', token)
      let res = await save_from_token(
        this.project_id,
        token,
        this.export_file.path
      )
      this.disabled_export = false
    },
  },
}
</script>
